<template>
  <main class="about">
    <div class="text">
      <div class="li flex lundi" v-if="about.tagline">
        <h1 class="sli lundi" v-html="about.tagline"></h1>
      </div>
      <div class="li flex" v-for="(text, index) in about.content" :key="index">
        <div class="sli top lundi">{{ text.title }}</div>
        <div v-if="text.text.length > 0" class="sli" v-html="text.text"></div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "about",
  data() {
    return {
      lang: "en"
    };
  },
  created() {
    if (this.$store.state.about.length === 0) {
      this.$store.dispatch("loadAbout");
    }
  },
  computed: {
    site() {
      return this.$store.state.site;
    },
    about() {
      return this.$store.state.about;
    }
  }
};
</script>

<style lang="scss" scoped>
.about {
  display: grid;
  grid-template-columns: minmax(auto, 700px) 1fr;
  grid-gap: var(--lh);
  @media only screen and (max-width: 768px) {
    grid-template-columns: 1fr;
  }
  .contact,
  .text {
    grid-column: span 1;
  }
}
</style>
